module.exports = __webpack_public_path__ + "img/zhxy-2.c84bb2ad.png";